import styled from "styled-components";

export const TableLoadingWrapper = styled.div`
  position: relative;
  min-height: 30vh;
  width: 100%;
  margin-bottom: 20px;
`;
